import { useEffect, useState } from 'react';

export const useIsMounted = () => {
  const [isMounted, setMounted] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setMounted(true);
  }, []);

  return isMounted;
};
